import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { EavEntityTypeFindManyQueryInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-find-many-query.dto';
import type { EavEntityTypeFindInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-find.dto';
import type { EavEntityTypeItemsPageInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-items-page.dto';
import type { EavEntityTypePageInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-page.dto';
import type { EavEntityTypeRegistryQueryInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-registry-query.dto';
import type { EavAttributeFormInterface } from '@zaoblako/shared/modules/eav/dtos/attribute/eav-attribute-form.dto';
import type { EavComputedAttributeTokenInterface } from '@zaoblako/shared/modules/eav/dtos/eav-computed-attribute-token.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisCatalogEavEntityTypeService extends BaseService {
  protected baseUrl = '/basis/catalog/eav-entity-type';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: EavEntityTypeRegistryQueryInterface): Observable<EavEntityTypeItemsPageInterface> {
    return this.http.get<EavEntityTypeItemsPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public findWithPagination(
    queryParams: EavEntityTypeFindManyQueryInterface | EavEntityTypeRegistryQueryInterface
  ): Observable<EavEntityTypePageInterface | EavEntityTypeItemsPageInterface> {
    return this.findPage(queryParams as EavEntityTypeRegistryQueryInterface);
  }

  public restoreOne(id: number): Observable<EavEntityTypeFindInterface> {
    return this.http.post<EavEntityTypeFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getTokensForAttributes(attributes: EavAttributeFormInterface[]): Observable<EavComputedAttributeTokenInterface[]> {
    return this.http.post<EavComputedAttributeTokenInterface[]>(`${this.baseUrl}/tokens`, { attributes });
  }
}
